Router = App.loadClass 'core::Router'
Storage = App.loadClass 'core::Storage'

class exports.DataRouter extends Router

    prefix: 'Data'
    module_name: 'DataRouter'

    # TODO: this should probably be broken up to make it easier to find things
    register: () ->
        @module = angular.module @module_name, ['ui.router', 'ui.bootstrap']

        # Custom filter to allow searching by farm or field name
        # 'collection' is the array of items we are working with (fields)
        # 'text' is the search string typed into the ui-select box
        @module.filter 'fieldFilter', () ->
            (collection, text) ->
                # Skip processing unless the user provides us a string
                return collection unless text isnt  ''

                # Here we search the collection for a match and return
                # the new list. Converting everything to lowercase
                # to provide case-insensitive searches
                list = []
                text = text.toLowerCase()

                for field in collection

                    farm_name = field.farm_name.toLowerCase()
                    field_name = field.field_name.toLowerCase()

                    if farm_name.indexOf(text) isnt -1 or field_name.indexOf(text) isnt -1
                        list.push(field)

                return list

        @module.filter 'yearFilter', () ->
            (collection, text) ->
                return collection unless text isnt ''

                list = []

                for year in collection
                    year = year.toString()

                    if year.indexOf(text) isnt -1
                        list.push(year)

                return list

        @module.filter 'numFilter', () ->

            (collection, text) ->
                # Skip processing unless the user provides us a string
                return collection unless text isnt  ''

                # Here we search the collection for a match and return
                # the new list. Converting everything to lowercase
                # to provide case-insensitive searches
                list = []

                for num, i in collection

                    num = num.toString()
                    list.push(num) if num.indexOf(text) isnt -1

                return list

        # Generic Sidebar Service
        @service 'grower::Angular/Data/Services/DataSidebarService', [
            '$http',
            '$rootScope',
            'Core.Services.Loading'
        ]

        # Map Legened Service
        @service 'grower::Angular/Data/PlantingRx/Services/LegendService', ['$rootScope']

        # Service for Legacy Handlers/Dialogs
        @service 'grower::Angular/Data/Services/LegacyHandlerService', [
            '$rootScope'
            '$timeout'
            'Data.Services.LegendService'
        ]

        # Service for User Selection within the Sidebar
        @service 'grower::Angular/Data/Services/UserSelectionService', ['$rootScope']

        # Download Service
        @service 'grower::Angular/Data/Services/DownloadService', ['$http', '$window', '$uibModal']

        # Map Conversion Service
        @service 'grower::Angular/Data/Add/Maps/Upload/Conversion/Services/MapsConversionService', [
            '$http',
            '$rootScope',
            '$window'
        ]

        # View Tab Controller
        @controller 'grower::Angular/Data/ViewController', [
            '$state'
            '$scope',
            '$transitions'
            'Data.Services.DataSidebarService'
            '$window'
            'Data.Services.LegacyHandlerService'
            '$uibModal'
            'Data.Services.UserSelectionService'
            'Core.Services.Loading'
            'Data.Services.DownloadService'
            '$stateParams'
            '$q'
            '$ngModal'
            '$http'
        ]

        # Add Tab Controller
        @controller 'grower::Angular/Data/Add/AddController', [
            '$scope', '$transitions',
            'Data.Services.DataSidebarService',
            'Data.Services.LegacyHandlerService',
            '$state',
            'Data.Services.UserSelectionService',
            '$ngModal'
            '$http'
        ]

        # Irrigation details controller
        @controller 'grower::Angular/Data/IrrigationDetailsController', [
            '$scope', '$transitions', '$transition$', '$uibModalInstance',
            'FieldsDefine.Services.IrrigationDetails', '$q', '$ngModal'
        ]

        @controller 'grower::Angular/Fields/FieldDetailsController', [
            '$scope',
            '$http',
            '$transitions',
            '$transition$',
            '$uibModalInstance',
            '$q',
            '$rootScope'
        ]

    registerRoutes: ($stateProvider) ->
        $stateProvider

            .modalState 'grower.data.view.irrigation-details',
                url: '/irrigation-details/:layer_id/:year/:field_id'
                templateUrl: 'backend/grower/data/irrigation-details'
                controller: 'Data.Controllers.IrrigationDetailsController'
                windowClass: 'small_dialog'

            .modalState 'grower.data.view.field-details',
                url: '/field-details/:id/:year/:editing'
                templateUrl: 'backend/grower/fields/field-details-view'
                controller: 'Fields.Controllers.FieldDetailsController'
                windowClass: 'small_dialog'
